import { memoizeOne } from "../EasyProjectsCommon/memoizeOne";

const GetCollator = memoizeOne((culture: string) => new Intl.Collator(culture, { caseFirst: "upper" }));

export class SortUtility {
    public static sortWithLocalCompare = (a: string, b: string) => GetCollator(ep.currentCulture).compare(a, b);

    public static nameComparer = <T extends { Name: string }>(a: T, b: T) =>
        SortUtility.sortWithLocalCompare(a.Name, b.Name);

    /**
     * Create a comparer that places items first by a predicate (`true` before `false`)
     */
    public static placeFirstComparer =
        <T>(f: F1<T, boolean>) =>
        (a: T, b: T) => {
            const ab = f(a) ? 0 : 1;
            const bb = f(b) ? 0 : 1;

            return ab - bb;
        };

    public static by =
        <T>(...args: F2<T, T, number>[]) =>
        (a: T, b: T) => {
            for (const item of args) {
                let result = item(a, b);
                if (result !== 0) {
                    return result;
                }
            }
            return 0;
        };
}
